/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.media-detector[_ngcontent-%COMP%]{font-family:xs}@media (min-width:576px){.media-detector[_ngcontent-%COMP%]{font-family:sm}}@media (min-width:768px){.media-detector[_ngcontent-%COMP%]{font-family:md}}@media (min-width:992px){.media-detector[_ngcontent-%COMP%]{font-family:lg}}@media (min-width:1200px){.media-detector[_ngcontent-%COMP%]{font-family:lg}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9zcmMvbWFpbi9hbmd1bGFyL2FwcC9tZWRpYS1kZXRlY3Rvci9tZWRpYS1kZXRlY3Rvci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL25ldy13YXZlLS1udy1hZGVzYS11aS1waXBlbGluZS9zb3VyY2Uvc3JjL21haW4vYW5ndWxhci9hcHAvbWVkaWEtZGV0ZWN0b3IvbWVkaWEtZGV0ZWN0b3IuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/main/angular/$$_gendir/app/media-detector/media-detector.component.scss.shim.ngstyle.ts